import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../store/AuthContext';  // Adjust path as needed
import { FaMoneyBillWave, FaWallet, FaDownload, FaUpload, FaHistory } from 'react-icons/fa';

const Wallet = () => {
  const { user } = useAuth();   // Get logged-in user
  const [wallet, setWallet] = useState(null);
  const [amount, setAmount] = useState(0);
  const [error, setError] = useState('');

  const fetchWallet = async () => {
    if (!user?.id) {
      setError('User not logged in.');
      return;
    }

if (!user.id) {
  console.error("User ID is undefined!");
  return;
}
console.log("User from AuthContext:", user);

    try {
      const res = await axios.get(`http://localhost:5000/api/wallet/${user.id}`);
      setWallet(res.data);

      setError('');
    } catch (err) {
      setWallet(null);
      setError('Failed to fetch wallet data.');
      console.error(err);
    }
  };

  const handleAction = async (type) => {
    if (!amount || amount <= 0) {
      setError('Please enter a valid amount.');
      return;
    }

    try {
      await axios.post(`http://localhost:5000/api/wallet/${user.id}/${type}`, { amount });
      setAmount(0);
      setError('');
      fetchWallet();
    } catch (err) {
      setError(`Failed to ${type}.`);
      console.error(err);
    }
  };

  useEffect(() => {
    fetchWallet();
  }, [user]);

  if (!user) return <p>Please login to view your wallet.</p>;

  return (
    <div className="p-4 max-w-xl mx-auto">
      <h2 className="text-2xl font-bold mb-4 flex items-center gap-2">
        <FaWallet /> Wallet
      </h2>

      {error && <p className="text-red-600 mb-4">{error}</p>}

      <div className="bg-white shadow rounded-lg p-6">
        <p className="text-gray-700 text-lg">Available Balance:</p>
        <p className="text-3xl font-semibold text-green-600 flex items-center gap-2">
          <FaMoneyBillWave /> {wallet?.balance ?? 'N/A'} ETB
        </p>

        <input
          type="number"
          placeholder="Amount"
          value={amount}
          onChange={(e) => setAmount(Number(e.target.value))}
          className="mt-4 p-2 border rounded w-full"
        />

        <div className="flex gap-4 mt-4">
          <button
            onClick={() => handleAction('deposit')}
            className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 flex items-center gap-2"
          >
            <FaUpload /> Deposit
          </button>
          <button
            onClick={() => handleAction('withdraw')}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center gap-2"
          >
            <FaDownload /> Withdraw
          </button>
        </div>
      </div>

      <div className="mt-6 bg-white shadow rounded-lg p-4">
        <h3 className="text-xl font-bold mb-2 flex items-center gap-2">
          <FaHistory /> Transaction History
        </h3>
        {wallet?.transactions?.length > 0 ? (
          <ul>
            {wallet.transactions.map((tx, index) => (
              <li key={index} className="flex justify-between py-1">
                <span>{tx?.type?.toUpperCase() ?? 'N/A'}</span>
                <span>{tx?.amount ?? 'N/A'} ETB</span>
              </li>
            ))}
          </ul>
        ) : (
          <p>No transactions yet.</p>
        )}
      </div>
    </div>
  );
};

export default Wallet;
